<template>
	<div class="tab">
		<div class="mt-12 yx-form-wrap mb-16 pl-24 pr-24">
			<el-form inline :model="form" label-width="96px">
				<el-form-item label="达人昵称" v-if="$isPlatOr(['Dy', 'Ks'])">
					<el-input v-model="form.anchor_name" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="视频号昵称" v-if="$isSp()">
					<el-input v-model="form.anchor_name" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item :label="platformId | formatPlatformName('suf')" v-if="$isPlatOr(['Dy', 'Ks', 'Xhs'])">
					<el-input v-model="form.anchor_account" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item v-if="$isSp()" :label="platformId | formatPlatformName('suf')">
					<el-input v-model="form.anchor_uid" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="达人标签" prop="tags_id" v-auth="['my-talent:search-tags']">
					<SelectTag ref="selectTag" style="width: 100%" :collapseTags="true" type="1" :multiple="true" v-model="form.tag_ids"></SelectTag>
				</el-form-item>
				<el-form-item label="粉丝量" v-if="$isPlatOr(['Dy', 'Ks'])">
					<el-select v-model="form.fans_num" clearable placeholder="粉丝量">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in fansList" :key="index" />
					</el-select>
				</el-form-item>
				<el-form-item label="粉丝数" v-if="$isSp()">
					<el-select v-model="form.fans_num" clearable placeholder="粉丝量">
						<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in fansNum" :key="index" />
					</el-select>
				</el-form-item>
				<el-form-item label="主推类目" v-if="$isPlatOr(['Dy', 'Ks'])">
					<yx-category-select v-model="form.cate" addAll placeholder="请选择" :platformId="platformId" />
				</el-form-item>
				<el-form-item v-if="showStatus(1) && $isPlatOr(['Dy', 'Ks'])" label="建联次数">
					<div class="scope-input">
						<el-input v-model="form.contact_num_start" clearable placeholder="请输入" @input="inputChange($event, 'contact_num_start')"></el-input>
						<span class="flag">至</span>
						<el-input v-model="form.contact_num_end" clearable placeholder="请输入" @input="inputChange($event, 'contact_num_end')"></el-input>
					</div>
				</el-form-item>
				<template v-if="$isDy()">
					<!-- <el-form-item label="月橱窗销量额">
						<div class="scope-input">
							<el-input
								v-model="form.month_live_sale_min"
								clearable
								placeholder="请输入"
								@input="inputChange($event, 'month_live_sale_min')"
							></el-input>
							<span class="flag">至</span>
							<el-input
								v-model="form.month_live_sale_max"
								clearable
								placeholder="请输入"
								@input="inputChange($event, 'month_live_sale_max')"
							></el-input>
						</div>
					</el-form-item> -->
					<el-form-item label="场均销售额" v-if="$isDy()">
						<el-select v-model="form.live_sale" multiple collapse-tags filterable clearable placeholder="请选择">
							<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in liveSaleList" :key="index" />
						</el-select>
					</el-form-item>
				</template>
				<template v-if="$isKs()">
					<el-form-item label="30日销售额">
						<el-select v-model="form.fee_30" filterable clearable placeholder="请选择">
							<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in monthLiveSaleList" :key="index" />
						</el-select>
					</el-form-item>
					<el-form-item label="场均销售额">
						<el-select v-model="form.live_sale" multiple collapse-tags filterable clearable placeholder="请选择">
							<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in liveSaleList" :key="index" />
						</el-select>
					</el-form-item>
				</template>
				<template v-if="$isSp()">
					<el-form-item label="30日销售额">
						<el-select v-model="form.fee_30" filterable clearable placeholder="请选择">
							<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in monthLiveSaleList" :key="index" />
						</el-select>
					</el-form-item>
					<el-form-item label="场均销售额">
						<el-select v-model="form.live_sale" multiple collapse-tags filterable clearable placeholder="请选择">
							<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in liveSaleList" :key="index" />
						</el-select>
					</el-form-item>
				</template>
				<el-form-item label="跟进人" v-if="isAllDataView">
					<el-select v-model="form.user_id" filterable clearable placeholder="请选择">
						<el-option :label="item.name" :value="item.userId" v-for="(item, index) in partner_list" :key="index">
							<div class="flex flex-align-center">
								<span class="mr-8">{{ item.name }}</span>
								<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
								<el-tag v-else-if="item.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
							</div>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="showStatus(5)" label="转为失效时间">
					<el-date-picker
						v-model="loseTime"
						type="daterange"
						@change="changTime($event, 'loseTime')"
						value-format="timestamp"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="认领时间">
					<el-date-picker
						v-model="createTime"
						type="daterange"
						@change="changTime($event, 'createTime')"
						value-format="timestamp"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="达人等级" v-if="$isDy()">
					<el-select v-model="form.anchor_level" filterable placeholder="请选择">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in talentGradeList" :key="index" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getList">筛选</el-button>
					<el-button @click="onClear">清空</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div style="height: 16px" class="yx-background"></div>
		<Panel>
			<div class="mb-16 flex flex-align-center flex-just-between">
				<div class="flex flex-align-center">
					<div class="flex flex-align-center flex-just-between mr-16">
						<template v-if="$auth.hasPermi('system:talent:allocation/re-allocation')">
							<el-checkbox @change="checkeFun" v-model="allChecked" class="ml-12">当页全选</el-checkbox>
							<el-tooltip class="item ml-16" effect="dark" content="请先选择达人" placement="bottom" :disabled="selectLen ? true : false">
								<el-button @click="showDisTipDialog" type="primary">批量重新分配</el-button>
							</el-tooltip>
						</template>
					</div>

					<div class="flex">
						<template v-if="!showStatus(5)">
							<el-button v-if="$auth.hasPermi('system:talent:create')" type="primary" @click="showAddTalentDialog">新建达人</el-button>
							<el-tooltip class="item" effect="dark" content="请先选择达人" placement="bottom" :disabled="selectLen ? true : false">
								<el-button class="ml-8" @click="modifyCooperation()" v-auth="['my-talent:seller:partner-anchor:batch-modify']">修改状态</el-button>
							</el-tooltip>
							<template v-if="focus === 1">
								<el-button v-if="$auth.hasPermi('system:talent:lead-into')" @click="showImportDialog">导入</el-button>
							</template>
							<template v-if="focus === 2">
								<el-button v-if="$auth.hasPermi('system:emphasisTalent:lead-into')" @click="showImportDialog">导入</el-button>
							</template>
						</template>
						<el-tooltip class="item" effect="dark" content="请先选择达人" placement="bottom" :disabled="selectLen ? true : false">
							<el-button class="ml-8" @click="handleBatchCancelClaim()" v-if="$auth.hasPermi('my-talent:cancleClaimBatch')">取消认领</el-button>
						</el-tooltip>
						<el-tooltip
							content="请先选择达人"
							:disabled="!!selectionTalent.length"
							placement="top"
							v-if="$auth.hasPermi('my-talent:tags:batch-set-anchor-tags')"
						>
							<el-button @click="addTags" style="margin-left: 12px">批量打标</el-button>
						</el-tooltip>
					</div>
					<button-group>
						<fold-button :buttons="btnList" btnText="更多操作" v-if="btnList.length"></fold-button>
					</button-group>
				</div>
				<div class="flex flex-align-center">
					<export-list
						v-if="$auth.hasPermi('system:talent:export')"
						ref="exportList"
						class="mr-12"
						:routerPath="routerPath"
						:platformId="platformId"
						:exportInterface="exportInterface"
						:exportDialog="exportDialog"
					></export-list>
					<el-checkbox v-if="!showStatus(5)" v-model="form.is_expire" :true-label="1" :false-label="0" @change="getList(true)">
						仅查看认领到期达人
					</el-checkbox>
				</div>
			</div>
			<multi-table
				class="mt-24"
				ref="multiTable"
				:page="pageInfo"
				:list="list"
				:columns="columns"
				:options="options"
				@gePartnerList="gePartnerPage"
				:selectionChange="talentChange"
				:total="total"
			>
				<template v-slot:empty>
					<div class="empty-page">
						<div class="i-empty-customer"></div>
						<div class="text">暂无达人数据</div>
						<div class="btns" v-if="showStatus(1) && focus !== 2">
							<el-button type="primary" v-if="$auth.hasPermi('system:groupSeas:claimant')" plain @click="goToClueSeasPage">公海认领</el-button>
							<el-button v-if="$auth.hasPermi('system:talent:create')" type="primary" @click="showAddTalentDialog">添 加</el-button>
							<el-button v-if="$auth.hasPermi('system:talent:lead-into')" type="primary" @click="showImportDialog">批量添加</el-button>
						</div>
					</div>
				</template>
			</multi-table>
		</Panel>
		<!-- 修改状态 -->
		<modify-cooperation-status ref="modifyCooperationStatus" source="private" @refresh="modifyCooperRefresh"></modify-cooperation-status>
		<delete-dialog ref="deleteDialog" @refresh="refresh"></delete-dialog>
		<allocation-dialog ref="allocationDialog" @getList="getList" :drnums="selectLen" :platform_id="platformId" />
		<el-dialog title="提示" :visible.sync="disTipDialog" width="426px" class="tipDialog">
			<i class="el-icon-warning mr-6" style="color: #ff7038"></i>
			<span>若选中的达人正在进行分配任务, 继续操作将按此次操作分配选中达人</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="disTipDialog = false">取 消</el-button>
				<el-button type="primary" @click="showAllocationDialog">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 添加标签 -->
		<tagDialog ref="tagDialog" type="1" @refreshList="refresh"></tagDialog>

		<cancelClaimDialog @handleOpenReconds="handleBatchCancelReconds" ref="cancelClaimDialog" :platform_id="platformId" @refresh="refresh" />

		<cancelRecondsDrawer ref="cancelRecondsDrawer" :platformId="platformId" @refresh="refresh" />

		<!-- 加入黑名单 -->
		<join-black-list-dialog ref="joinBlackListDialog" :platformId="platformId" @refresh="getList" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import throttle from 'lodash/throttle';
import allocationDialog from '../allocationDialog';
import { fansList, talentGradeList, authStatusList } from '@/utils/dataMap';
import { getTalentManageList, setTalentFocus, effectTalent, talentExport } from '@/api/talentCRM';
import { startOfDay, endOfDay } from 'date-fns';
import deleteDialog from '../deleteDialog';
import yxCategorySelect from '@/components/yxCategorySelect';
import exportList from '@/views/common/exportList';
import { getColums } from './columns';
import SelectTag from '@/components/business/tagDialog/selectTag';
import tagDialog from '@/components/business/tagDialog';
import cancelClaimDialog from '../cancelClaimDialog/index.vue';
import cancelRecondsDrawer from '../cancelRecondsDrawer/index.vue';
import ModifyCooperationStatus from '@/views/talentCRM/components/modifyCooperationStatus/index.vue';
import foldButton from '@/components/ui/foldButton';
import ButtonGroup from '@/components/ui/buttonGroup';
import joinBlackListDialog from '@/views/talentCRM/components/joinBlackListDialog';
export default {
	name: 'tab',
	components: {
		ModifyCooperationStatus,
		deleteDialog,
		allocationDialog,
		yxCategorySelect,
		exportList,
		SelectTag,
		tagDialog,
		cancelClaimDialog,
		cancelRecondsDrawer,
		foldButton,
		ButtonGroup,
		joinBlackListDialog,
	},
	props: {
		cooperateStatus: {
			type: Number,
			default: 1,
		},
		focus: {
			type: Number,
			default: 0,
		},
		partner_list: {
			type: Array,
			default: () => [],
		},
		liveSaleList: {
			type: Array,
			default: () => [],
		},
		monthLiveSaleList: {
			type: Array,
			default: () => [],
		},
		fansNum: {
			type: Array,
			default: () => [],
		},
		platformId: {
			type: [String, Number],
			default: 1,
		},
	},
	provide() {
		return {
			refresh: this.getList,
		};
	},
	data() {
		return {
			fansList,
			talentGradeList,
			authStatusList,
			form: {
				anchor_name: '',
				anchor_account: '',
				user_id: '',
				fans_num: 0,
				anchor_level: -1,
				cate: '',
				contact_num_start: '',
				contact_num_end: '',
				uneffect_time_start: 0,
				uneffect_time_end: 0,
				add_time_start: 0,
				add_tim_end: 0,
				is_expire: 0,
				fee_30: 0,
				live_sale: 0,
				month_live_sale_min: '',
				month_live_sale_max: '',
			},
			options: {
				selectable: true,
				border: false,
			},
			loseTime: [],
			createTime: [],
			list: [],
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			many_partner: 0,
			routerPath: '/talentCRM/record',
			allChecked: false,
			selectionTalent: [],
			filterArr: [],
			hasTask: true, //暂时定位有存在任务的人
			disTipDialog: false,
			allocationDialog: false,
			source: '', //是否单个分配
		};
	},
	computed: {
		...mapGetters(['isAllDataView']),
		selectLen() {
			return this.selectionTalent.length;
		},
		showStatus() {
			return (...status) => {
				return [...status].includes(+this.cooperateStatus);
			};
		},
		columns() {
			const columns = getColums(this).filter(item => {
				return item.isAuth && item.show;
			});
			return columns;
		},
		btnList() {
			let arr = [];
			arr = [
				{
					btnTxt: '分配记录',
					disabled: false,
					key: 'allocationRecord',
					isShow: this.$auth.hasPermi('system:allocatedRecord-query') && this.$auth.hasPermi('system:talent:allocation/re-allocation'),
					click: () => {
						this.gotoAllocatedRecord();
					},
				},
				{
					btnTxt: '导入记录',
					disabled: false,
					key: 'importRecord',
					tip: '',
					showTip: false,
					isShow: this.$auth.hasPermi('system:talent:lead-intoPage') && this.focus === 1 && !this.showStatus(5),
					click: () => {
						this.goToPage();
					},
				},
				{
					btnTxt: '导入记录',
					disabled: false,
					key: 'importRecord',
					tip: '',
					showTip: false,
					isShow: this.$auth.hasPermi('system:emphasisTalent:lead-intoPage') && this.focus === 2 && !this.showStatus(5),
					click: () => {
						this.goToPage();
					},
				},
				{
					btnTxt: '取消认领记录',
					disabled: false,
					key: 'cancelRecord',
					tip: '',
					showTip: false,
					isShow: this.$auth.hasPermi('my-talent:cancleClaimReconds'),
					click: () => {
						this.handleBatchCancelReconds();
					},
				},
				{
					btnTxt: '加入黑名单',
					disabled: false,
					key: 'joinBlackbtn',
					isShow: this.$auth.hasPermi('my-talent:blacklist-anchor:block'),
					click: () => {
						this.joinBlackList(
							'batch',
							this.selectionTalent.map(item => item.anchor_id),
						);
					},
				},
			];

			return arr.filter(v => v.isShow);
		},
	},
	methods: {
		showDisTipDialog() {
			if (this.selectionTalent.length == 0) return;
			this.source = 'talentGroup'; //批量分配
			//等待接口，判断是否有大人存在任务，赋值hasTask
			//所有达人中有存在任务的
			if (this.hasTask) {
				this.disTipDialog = true; //显示提示框
			} else {
				this.disTipDialog = false;
				this.$refs.allocationDialog.Show(this.source);
			}
		},
		talentChange(val) {
			this.selectionTalent = val;
			//如果商品总数小于当前分页的总数，那么当长度等于total，为全选 如果商品总数大于当前的分页，那么长度等于当前的分页
			if (this.total <= this.pageInfo.page_size) {
				if (this.selectLen == this.total) return (this.allChecked = true);
			} else {
				if (this.selectLen == this.pageInfo.page_size) return (this.allChecked = true);
			}
			this.allChecked = this.selectLen && this.selectLen === this.filterArr.length;
		},
		//选中值
		checkeFun(e) {
			this.filterArr = [];
			this.filterArr = this.list.filter(item => ![2, 3].includes(item.other_status));
			this.$refs.multiTable.toggleSelection(this.list, e);
		},
		inputChange(val, attr) {
			this.form[attr] = +val.replace(/\D/g, '') || '';
		},
		changTime(val, flag) {
			const setTime = ([startTime, endTime], start, end) => {
				this.form[start] = startTime && Math.trunc(startOfDay(startTime) / 1000);
				this.form[end] = endTime && Math.trunc(endOfDay(endTime) / 1000);
			};
			const obj = {
				loseTime: time => setTime(time, 'uneffect_time_start', 'uneffect_time_end'),
				createTime: time => setTime(time, 'add_time_start', 'add_tim_end'),
			};
			obj[flag](val || ['', '']);
		},
		getList: throttle(async function (isInit) {
			isInit && this.resetPage();
			const { form, pageInfo, cooperateStatus: cooperate_status, focus, platformId: platform_id } = this;
			let formCopy = {};
			Object.keys(form).forEach(key => {
				formCopy[key] = Array.isArray(form[key]) ? form[key].join(',') : form[key];
			});

			const { code, data: { list = [], page = {}, many_partner } = {} } = await getTalentManageList({
				...formCopy,
				...pageInfo,
				cooperate_status,
				focus,
				platform_id,
			});
			if (code !== 0) return;
			this.many_partner = many_partner;
			this.list = list.map(item => {
				return {
					...item,
					many_partner: many_partner,
					operations: this.getButtons(item),
				};
			});
			this.total = page.item_total;
		}, 1000),
		onClearData() {
			this.form = {
				anchor_name: '',
				anchor_account: '',
				user_id: '',
				fans_num: 0,
				anchor_level: -1,
				cate: '',
				contact_num_start: '',
				contact_num_end: '',
				uneffect_time_start: 0,
				uneffect_time_end: 0,
				add_time_start: 0,
				add_tim_end: 0,
				is_expire: 0,
				fee_30: 0,
				live_sale: 0,
				month_live_sale_min: '',
				month_live_sale_max: '',
			};
			this.$refs.selectTag?.reset();
			this.followTime = [];
			this.createTime = [];
			this.loseTime = [];
		},
		onClear() {
			this.onClearData();

			this.getList(true);
		},
		resetPage() {
			this.pageInfo.page_index = 1;
			this.$refs.multiTable.resetPage();
		},
		getButtons(item) {
			const arr = [];
			arr.push(
				{
					label: '建联',
					type: 'text',
					classtype: 2,
					isShow: this.showStatus(1) && this.$auth.hasPermi('system:talent:Construction') && this.isSelf(item.user_id),
					click: row => this.showRelationDialog(row),
				},
				{
					label: '推品',
					type: 'text',
					classtype: 2,
					isShow: this.showStatus(2, 4) && this.$auth.hasPermi('system:talent:push-product') && this.isSelf(item.user_id),
					click: row => this.goToGoodsPage(),
				},
				{
					label: '恢复',
					type: 'text',
					classtype: 2,
					isShow: this.showStatus(5) && this.$auth.hasPermi('system:tanlent:recover') && this.isSelf(item.user_id),
					click: row => this.activateTalent(row.anchor_id),
				},
				{
					label: `${item.focus == 1 ? '重点' : '取消'}关注`,
					type: 'text',
					classtype: 2,
					isShow: !this.showStatus(5) && this.$auth.hasPermi('system:talent:attention') && this.isSelf(item.user_id),
					click: row => this.setTalentFocus(row.p_id, row.focus),
				},
				{
					label: '编辑',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:talent:edit-talent') && this.isSelf(item.user_id),
					click: row => this.showUpdateTalentDialog(row.anchor_id),
				},
				{
					label: '重新分配',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:talent:allocation/re-allocation'),
					click: row => this.reAllocated(row.anchor_id, 'talentSingle', row.user_id),
				},
				{
					label: '详情',
					type: 'text',
					classtype: 2,
					isShow: true,
					click: row => this.showdetailDrawer(row.anchor_id),
				},
				{
					label: '修改状态',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('my-talent:seller:partner-anchor:batch-modify'),
					click: row => this.modifyCooperation(row.p_id),
				},
				{
					label: '取消认领',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('my-talent:cancleClaim'),
					click: row => {
						this.$refs.cancelClaimDialog.show(row.p_id);
					},
				},
				{
					label: '加入黑名单',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('my-talent:blacklist-anchor:block'),
					click: row => {
						this.joinBlackList('single', row.anchor_id);
					},
				},
			);
			let filterArr = arr.filter(v => v.isShow);
			filterArr.tagDialog = this.addTag;
			return filterArr;
		},
		handleBatchCancelClaim() {
			if (!this.selectLen) return;
			const partnerAnchorIds = this.selectionTalent.map(item => item.p_id);
			this.$refs.cancelClaimDialog.show(partnerAnchorIds, 'batch');
		},
		handleBatchCancelReconds() {
			this.$refs.cancelRecondsDrawer.show();
		},
		//加入黑名单
		joinBlackList(type = 'single', val) {
			if (type === 'batch') {
				if (!this.selectionTalent.length) {
					this.$message.warning('请选择达人');
					return;
				}
			}
			this.$refs.joinBlackListDialog.show(type, val);
		},
		showUpdateTalentDialog(anchor_id) {
			this.$emit('showAddTalentDialog', anchor_id);
		},
		gePartnerPage(val) {
			const { page_index, page_size } = val;
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getList();
		},
		showRelationDialog(row) {
			this.$emit('showRelationDialog', row);
		},
		showAddTalentDialog() {
			this.$emit('showAddTalentDialog');
		},
		// 修改状态
		async modifyCooperation(val = '') {
			if (val) {
				this.$refs.modifyCooperationStatus.show(val, [1]);
			} else {
				if (!this.selectLen) return;
				let partnerAnchorIds = this.selectionTalent.map(item => item.p_id);
				this.$refs.modifyCooperationStatus.show(val, partnerAnchorIds, 0, 'myTalent');
			}
		},
		reAllocated(anchor_id, source, user_id) {
			this.source = 'talentSingle';
			this.showAllocationDialog(anchor_id, source, user_id);
		},
		showAllocationDialog(anchor_id, source, user_id) {
			this.disTipDialog = false;
			//判断是单独还是批量分配
			if (this.source == 'talentSingle') {
				this.$refs.allocationDialog.show(anchor_id, source, user_id);
			} else if (this.source == 'talentGroup') {
				this.$refs.allocationDialog.Show(this.selectionTalent, this.source);
			}
		},
		setTalentFocus: throttle(async function (id, focus) {
			focus = focus == 1 ? 2 : 1;
			const { code } = await setTalentFocus({ id, focus });
			if (code !== 0) return;
			this.$message.success(`${focus == 1 ? '取消' : '重点'}关注成功`);
			this.getList();
			this.$emit('getTalentManageTab');
		}, 1000),
		goToClueSeasPage() {
			this.$router.push('/talentCRM/clueSeas');
		},
		gotoAllocatedRecord() {
			const { platformId: platform_id } = this;
			const openCatedRecord = this.$router.resolve({
				path: '/talentCRM/allocatedrecord',
				query: { platform_id },
			});
			window.open(openCatedRecord.href, '_blank');
		},
		async activateTalent(anchor_id) {
			const confirm = await this.$confirm('是否确认恢复？恢复后达人将恢复到原来的合作状态', '提示').catch(err => err);
			if (confirm !== 'confirm') return;
			const { code } = await effectTalent({ anchor_id });
			if (code !== 0) return;
			this.$message.success('恢复成功');
			this.getList();
			this.$emit('getTalentManageTab');
		},
		showdetailDrawer(anchor_id) {
			this.$emit('showdetailDrawer', anchor_id);
		},
		goToGoodsPage() {
			this.$router.push('/shopManage/shopLibrary/list');
		},
		showImportDialog() {
			this.$emit('showImportDialog');
		},
		refresh() {
			this.getList();
		},
		modifyCooperRefresh() {
			this.$emit('getTalentManageTab');
			this.getList();
		},
		goToPage() {
			const url = ['', '/talentCRM/myTalent/importLog', '/talentCRM/emphasisTalent/importLog'][this.focus];
			this.$router.push(url);
		},
		async exportInterface(that) {
			const { form, pageInfo, cooperateStatus: cooperate_status, focus, platformId: platform_id } = this;
			let formCopy = {};
			Object.keys(form).forEach(key => {
				formCopy[key] = Array.isArray(form[key]) ? form[key].join(',') : form[key];
			});
			const { code } = await talentExport({ ...formCopy, ...pageInfo, cooperate_status, platform_id, focus, exprot_type: focus - 1, opt_type: 1 });
			if (code === 0) {
				that.$refs.exportDialog.show(this.exportDialog);
			}
		},
		async exportDialog() {
			const { form, pageInfo, cooperateStatus: cooperate_status, focus, platformId: platform_id, routerPath } = this;
			let formCopy = {};
			Object.keys(form).forEach(key => {
				formCopy[key] = Array.isArray(form[key]) ? form[key].join(',') : form[key];
			});
			const { code } = await talentExport({ ...formCopy, ...pageInfo, cooperate_status, platform_id, focus, exprot_type: focus - 1, opt_type: 2 }); //exprot_type, 0 我的达人， 1 重点关注
			if (code === 0) {
				const handLink = this.$router.resolve({
					path: routerPath,
					query: { platform_id },
				});
				window.open(handLink.href, '_blank');
			}
		},
		addTag(row) {
			this.$refs.tagDialog.show('编辑标签', [row]);
		},
		addTags() {
			if (!this.selectionTalent.length) return;
			this.$refs.tagDialog.show('批量添加标签', this.selectionTalent);
		},
	},
};
</script>

<style lang="less" scoped>
.tab {
	.empty-page {
		margin-top: 100px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.i-empty-customer {
			width: 240px;
			height: 240px;
		}

		.text {
			font-size: 16px;
			color: #999999;
			margin-top: 24px;
		}

		.btns {
			margin-top: 32px;
			z-index: 100;
		}
	}

	.import-log {
		font-size: 14px;
		color: #333;
		display: flex;
		align-items: center;
		cursor: pointer;
		margin-left: 8px;

		.iconfont {
			font-size: 24px;
			vertical-align: middle;
		}

		&:hover {
			color: @color-primary;
		}
	}
}
</style>
